import React, { useState } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import size from "lodash/size";

import FileItem from "../upload/FileItem";
import { useFileContext } from "../context/FileWrapper";
import AssociationModal from "./AssociationModal";

const FilesList = ({ isModalView, estateId }) => {
  const { selectedFiles, filesAssociation, onRemove, addAssociation } =
    useFileContext();

  const [selectedFile, setSelectedFile] = useState(null);
  const [open, setOpen] = useState(false);

  const onEdit = (file) => {
    setSelectedFile(file);
    setOpen(true);
  };

  const onCloseAssociationModal = () => {
    setOpen(false);
    setSelectedFile(null);
  };

  return (
    <Box
      className="d-flex flex-column"
      sx={{
        marginTop: "20px",
        gap: "20px",
        height: isModalView ? "250px" : "auto",
        maxHeight: isModalView ? "250px" : "auto",
        overflowY: isModalView ? "auto" : "visible",
      }}
    >
      <Typography color="var(--text-color)" fontSize={26} fontWeight={700}>
        Associez les documents
      </Typography>
      <Stack gap={2}>
        {selectedFiles.map((file) => (
          <FileItem
            file={file}
            key={file.uuid}
            uuid={file.uuid}
            filename={file.name}
            extension={file.extension}
            size={file.sizeMo}
            effectiveDate={file.effectiveDateStr}
            documentType={file.documentTypeName}
            onRemove={() => onRemove(file.uuid)}
            association={filesAssociation[file.uuid]}
            onChangeAssociation={(estates) =>
              addAssociation(file.uuid, estates)
            }
            onEdit={() => onEdit(file)}
            estateId={estateId}
            isModalView={isModalView}
          />
        ))}
      </Stack>
      {open && !!selectedFile && (
        <AssociationModal
          open={open}
          onClose={onCloseAssociationModal}
          selectedFile={selectedFile}
        />
      )}
    </Box>
  );
};

export default FilesList;
